/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData model module.
 * @module model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData
     */
    constructor() { 
        
        EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData} The populated <code>EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData();

            if (data.hasOwnProperty('packNo')) {
                obj['packNo'] = ApiClient.convertToType(data['packNo'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('needUsedPower')) {
                obj['needUsedPower'] = ApiClient.convertToType(data['needUsedPower'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('rewardXper')) {
                obj['rewardXper'] = ApiClient.convertToType(data['rewardXper'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1')) {
                obj['rewardItem1'] = ApiClient.convertToType(data['rewardItem1'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1Count')) {
                obj['rewardItem1Count'] = ApiClient.convertToType(data['rewardItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2')) {
                obj['rewardItem2'] = ApiClient.convertToType(data['rewardItem2'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2Count')) {
                obj['rewardItem2Count'] = ApiClient.convertToType(data['rewardItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3')) {
                obj['rewardItem3'] = ApiClient.convertToType(data['rewardItem3'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3Count')) {
                obj['rewardItem3Count'] = ApiClient.convertToType(data['rewardItem3Count'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} packNo
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['packNo'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['regDuration'] = undefined;

/**
 * @member {Number} needUsedPower
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['needUsedPower'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['endAt'] = undefined;

/**
 * @member {Number} rewardXper
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardXper'] = undefined;

/**
 * @member {Number} rewardItem1
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem1'] = undefined;

/**
 * @member {Number} rewardItem1Count
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem1Count'] = undefined;

/**
 * @member {Number} rewardItem2
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem2'] = undefined;

/**
 * @member {Number} rewardItem2Count
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem2Count'] = undefined;

/**
 * @member {Number} rewardItem3
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem3'] = undefined;

/**
 * @member {Number} rewardItem3Count
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['rewardItem3Count'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['createdAt'] = undefined;

/**
 * @member {Number} walletNo
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['walletNo'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['initialXper'] = undefined;

/**
 * @member {Number} balanceXper
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['balanceXper'] = undefined;

/**
 * @member {Number} userCount
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['userCount'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData.prototype['depositTransactionStatus'] = undefined;






export default EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData;

